module.exports = __webpack_public_path__ + "static/media/business.2fd3a143.jpg";